import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromSearchModal from '../reducers/search-modal.reducers';
import { SearchModalState } from '../reducers';

export const getSearchModalState = createFeatureSelector<fromSearchModal.SearchModalState>('searchModal');

export const isModalOpen = createSelector(getSearchModalState, (state: SearchModalState) => state.open);
